<template>
  <!-- -->
  <div class="defaultViewStyle">
    <list-page>
      <el-tabs v-model="activeName">
        <el-tab-pane label="商户服务" name="service">
          <el-descriptions :column="2" border>
            <el-descriptions-item label="商户名称">{{merchantInfo.merchantName}}</el-descriptions-item>
            <el-descriptions-item label="有效期"><yq-date-range :disabled="true" v-model:start-time="merchantInfo.validStart" v-model:end-time="merchantInfo.validEnd"/> </el-descriptions-item>
            <el-descriptions-item label="负责人">{{merchantInfo.legalPerson}}</el-descriptions-item>
            <el-descriptions-item label="企业地址">{{merchantInfo.address}}</el-descriptions-item>
            <el-descriptions-item label="营业执照">{{merchantInfo.businessLicense}}</el-descriptions-item>
            <el-descriptions-item label="手机号">{{merchantInfo.merchantPhone}}</el-descriptions-item>
            <el-descriptions-item label="区域编码"><administrative v-model="merchantInfo.regionCode" :disabled="true"/> </el-descriptions-item>
            <el-descriptions-item label="推荐码" :span="2">{{merchantInfo.evaluationCode}}</el-descriptions-item>
            <el-descriptions-item label="商户简介" :span="2">{{merchantInfo.merchantDesc}}</el-descriptions-item>
          </el-descriptions>
          <form-tag label="已开通服务">
            <page-button el-type="primary" @click="grantService">授权</page-button>
          </form-tag>
          <div>
            <el-checkbox-group v-model="selectedService">
              <el-checkbox v-for="ser in serviceList" :label="ser.serviceName" :value="ser.id" :key="ser.id"/>
            </el-checkbox-group>
          </div>
          <form-tag label="企业微信功能">
            <!-- 未对接：可选对接方式 -->
            <template v-if="!qywxBuilt">
              <page-button v-if="!qywxChoosing" el-type="primary" @click="qywxChoosing = true">设置对接方式</page-button>
              <template v-else>
                <page-button el-type="primary" @click="chooseAppType(QYWX_APP_SELF)">自建应用对接</page-button>
                <page-button el-type="success" @click="chooseAppType(QYWX_APP_SAAS)">saas应用对接</page-button>
                <page-button @click="qywxChoosing = false">取消</page-button>
              </template>
            </template>
            <!-- 待确认：可取消并重新发起 -->
            <template v-else-if="qywxPending">
              <page-button @click="reopenAuthUrl">重新打开授权链接</page-button>
              <page-button el-type="danger" @click="cancelBuild">取消授权</page-button>
            </template>
          </form-tag>
          <div>
            <!-- 未对接 -->
            <div v-if="!qywxBuilt" class="qywx-empty">该商户尚未对接企业微信</div>
            <!-- 已对接：展示对接方式与授权状态 -->
            <el-descriptions v-else :column="2" border>
              <el-descriptions-item label="对接方式">
                <el-tag :type="qywxAppTypeTag" size="small">{{ qywxAppTypeText }}</el-tag>
              </el-descriptions-item>
              <el-descriptions-item label="授权状态">
                <el-tag :type="qywxStatusTag" size="small">{{ qywxStatusText }}</el-tag>
              </el-descriptions-item>
              <!-- 自建应用：展示 corpId 与应用id -->
              <template v-if="qywxInfo.qywxAppType === QYWX_APP_SELF">
                <el-descriptions-item label="企业ID(corpId)">{{ qywxInfo.qywxCorpId || '—' }}</el-descriptions-item>
                <el-descriptions-item label="应用ID(agentId)">{{ qywxInfo.qywxAgentId || '—' }}</el-descriptions-item>
                <el-descriptions-item label="主页地址" :span="2">
                  <a class="qywx-copy-url" @click="copyHomePageUrl">{{ qywxInfo.homePageUrl }}</a>
                  <div class="qywx-hint">
                    点击即可复制，粘贴到企业微信后台：应用管理 → 自建应用 → 应用主页。
                    域名取当前访问域名，更换域名后回到本页重新复制即可
                  </div>
                </el-descriptions-item>
              </template>
              <!-- saas待确认：展示扫码授权链接 -->
              <template v-if="qywxPending && qywxInfo.authUrl">
                <el-descriptions-item label="扫码授权链接" :span="2">
                  <el-link type="primary" :href="qywxInfo.authUrl" target="_blank">{{ qywxInfo.authUrl }}</el-link>
                  <div class="qywx-hint">请企业微信管理员打开链接扫码授权，授权成功后状态自动变为「已确认」</div>
                </el-descriptions-item>
              </template>
            </el-descriptions>
          </div>
        </el-tab-pane>
        <el-tab-pane label="角色授权" name="role" lazy>
          <roles :merchant-id="merchantInfo.id"/>
        </el-tab-pane>
        <el-tab-pane label="商户职员" name="employee" lazy>
          <plat-merchant-employees :id="merchantInfo.id"/>
        </el-tab-pane>
      </el-tabs>
    </list-page>

    <!-- 自建应用对接弹窗 -->
    <el-dialog v-model="showSelfDialog" title="自建应用对接" dialog-width="2" :close-on-click-modal="false">
      <div class="qywx-hint">
        填写企业微信自建应用的参数，保存时后端会立即用这组参数换取 accessToken，
        换取成功才算对接完成（授权方式确认后不可再更改）。
      </div>
      <form-items :data="selfForm" :columns="1" label-width="4.6rem" ref="selfFormRef">
        <form-item label="企业ID" :required="true" name="qywxCorpId" error-message="请填写企业ID(corpId)">
          <el-input v-model="selfForm.qywxCorpId" placeholder="企业微信 → 我的企业 → 企业ID"/>
        </form-item>
        <form-item label="应用ID" :required="true" name="qywxAgentId" error-message="请填写应用ID(agentId)">
          <el-input-number v-model="selfForm.qywxAgentId" :min="1" :step="1" :controls="false" style="width: 100%"/>
        </form-item>
        <form-item label="应用Secret" :required="true" name="qywxAgentSecret" error-message="请填写应用Secret">
          <el-input v-model="selfForm.qywxAgentSecret" type="password" show-password
                    autocomplete="new-password" placeholder="应用详情页的Secret"/>
        </form-item>
      </form-items>
      <template #footer>
        <page-button @click="showSelfDialog = false">取消</page-button>
        <page-button type="write" el-type="primary" @click="saveSelfBuild">保存并验证</page-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import merchantApi from "@/api/normal/sys/merchantApi";
import YqDateRange from "@/components/h5/date/YqDateRange.vue";
import ListPage from "@/components/h5/layout/ListPage.vue";
import PlatMerchantEmployees from "./PlatMerchantEmployees.vue";
import Roles from "@/views/h5/common/basedata/role/RolesByMerchant.vue";
import PageButton from "@/components/h5/button/PageButton.vue";
import Administrative from "@/components/h5/data/Administrative.vue";
import Util from "@/util/util";
import {useRoute, useRouter} from "vue-router";
import FormTag from "@/components/h5/layout/FormTag.vue";
import FormItems from "@/components/h5/layout/FormItems.vue";
import FormItem from "@/components/h5/layout/FormItem.vue";

// 企业微信应用类型（类型字段，取值 1/2）
const QYWX_APP_SAAS = 1;
const QYWX_APP_SELF = 2;
// 授权确认状态（状态字段）
const QYWX_STATUS_NOT_BUILT = 0;
const QYWX_STATUS_PENDING = 100;
const QYWX_STATUS_CONFIRMED = 200;

export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "MerchantDetail",
  components: {
    PageButton, YqDateRange, ListPage, PlatMerchantEmployees, Roles, Administrative, FormTag, FormItems, FormItem
  },
  data() {
    return {
      merchantInfo: {},
      qywxInfo: {},
      activeName: "service",
      serviceList: [],
      selectedService: [],
      // 企业微信对接
      qywxChoosing: false,       // 是否处于「选择对接方式」态
      showSelfDialog: false,
      selfForm: {id: "", qywxCorpId: "", qywxAgentId: null, qywxAgentSecret: ""},
      // 常量暴露给模板
      QYWX_APP_SAAS, QYWX_APP_SELF,
    };
  },
  computed: {
    /** 是否已选择对接方式 */
    qywxBuilt() {
      return this.qywxInfo.qywxAppType != null;
    },
    /** 授权是否待确认 */
    qywxPending() {
      return this.qywxInfo.qywxAuthStatus === QYWX_STATUS_PENDING;
    },
    /** 授权是否已确认 */
    qywxConfirmed() {
      return this.qywxInfo.qywxAuthStatus === QYWX_STATUS_CONFIRMED;
    },
    qywxAppTypeText() {
      if (this.qywxInfo.qywxAppType === QYWX_APP_SAAS) return "saas应用对接";
      if (this.qywxInfo.qywxAppType === QYWX_APP_SELF) return "自建应用对接";
      return "未对接";
    },
    qywxAppTypeTag() {
      if (this.qywxInfo.qywxAppType === QYWX_APP_SAAS) return "success";
      if (this.qywxInfo.qywxAppType === QYWX_APP_SELF) return "primary";
      return "info";
    },
    qywxStatusText() {
      if (this.qywxInfo.qywxAuthStatus === QYWX_STATUS_CONFIRMED) return "已确认";
      if (this.qywxInfo.qywxAuthStatus === QYWX_STATUS_PENDING) return "待确认";
      return "未对接";
    },
    qywxStatusTag() {
      if (this.qywxInfo.qywxAuthStatus === QYWX_STATUS_CONFIRMED) return "success";
      if (this.qywxInfo.qywxAuthStatus === QYWX_STATUS_PENDING) return "warning";
      return "info";
    },
  },
  beforeRouteLeave(to, from, next) {
    // 将当前页面数据进行缓存
    Util.cachePageData(this, to, from);
    next();
  },
  created() {
    if (!Util.loadPageData(this)) { // 加载缓存数据失败，初始化页面
      merchantApi.findById(this.route.query.id).then(data => {
        this.merchantInfo = data;
      });
      // 企业微信信息
      this.loadQywxInfo();
      // 查询全部的服务
      merchantApi.queryAllService().then(list => this.serviceList = list);
      this.queryGrantResult();
    }
  },
  methods: {
    // 查询已被授权的服务
    queryGrantResult() {
      // 查询商户已被授权的服务
      merchantApi.queryMerchantService(this.route.query.id).then(list => {
        let arr = [];
        list.forEach(m => arr.push(m.serviceId));
        this.selectedService = arr;
      });
    },
    // 对商户进行授权
    grantService() {
      merchantApi.saveMerchantService(this.route.query.id, this.selectedService).then(() => this.queryGrantResult());
    },
    // ---------- 企业微信对接 ----------
    loadQywxInfo() {
      return merchantApi.findQywxInfoById(this.route.query.id).then(data => {
        this.qywxInfo = data || {};
        // 如果对接已完成，且是自建应用
        if (this.qywxInfo.qywxAppType === QYWX_APP_SELF && this.qywxInfo.qywxAuthStatus === QYWX_STATUS_CONFIRMED) {
          let redirectUri = encodeURIComponent(window.location.origin + "/qywx/self/login")
          this.qywxInfo.homePageUrl = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + this.qywxInfo.qywxCorpId + "&redirect_uri=" + redirectUri + "&response_type=code&scope=snsapi_privateinfo&state=" + this.route.query.id + "&agentid=" + this.qywxInfo.qywxAgentId + "#wechat_redirect";
        }
      });
    },
    /** 选择对接方式：自建应用弹表单，saas 直接发起授权 */
    chooseAppType(appType) {
      if (appType === QYWX_APP_SELF) {
        this.selfForm = {id: this.route.query.id, qywxCorpId: "", qywxAgentId: null, qywxAgentSecret: ""};
        this.showSelfDialog = true;
        return;
      }
      // saas：申请预授权码，拿到扫码链接后打开
      merchantApi.startSaasBuild(this.route.query.id).then(data => {
        this.qywxInfo = data || {};
        this.qywxChoosing = false;
        this.openAuthUrl(this.qywxInfo.authUrl);
      });
    },
    /** 提交自建应用参数：后端换token成功才会保存并确认 */
    async saveSelfBuild() {
      if (!this.$refs.selfFormRef.validCheck()) { // 数据验证不通过
        return;
      }
      const data = await merchantApi.saveSelfBuild(this.selfForm);
      this.qywxInfo = data || {};
      this.showSelfDialog = false;
      this.qywxChoosing = false;
      this.$message.success("自建应用对接成功");
    },
    /**
     * 复制自建应用主页地址到剪贴板（点击地址即复制，不跳转新页面）。
     *
     * 主页地址是一串带参数的授权链接，在企业微信里是配置项而不是给人点的，
     * 所以这里只复制、不打开，避免误点后离开当前页。
     */
    async copyHomePageUrl() {
      const text = this.qywxInfo.homePageUrl || "";
      if (!text) {
        return;
      }
      try {
        // 非 https / localhost 下 clipboard API 不可用，降级用 execCommand
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(text);
        } else {
          const ta = document.createElement("textarea");
          ta.value = text;
          ta.style.position = "fixed";
          ta.style.opacity = "0";
          document.body.appendChild(ta);
          ta.select();
          document.execCommand("copy");
          document.body.removeChild(ta);
        }
        this.$message.success("已复制主页地址，请前往企业微信进行设置");
      } catch (e) {
        this.$message.error("复制失败，请手动选择复制");
      }
    },
    /** 打开扫码授权链接 */
    openAuthUrl(url) {
      if (!url) {
        return;
      }
      window.open(url, "_blank");
    },
    /** 重新打开授权链接（待确认时用） */
    reopenAuthUrl() {
      this.openAuthUrl(this.qywxInfo.authUrl);
    },
    /** 取消授权：待确认时取消，回到未对接可重选方式 */
    async cancelBuild() {
      await this.$confirm("取消后本次授权作废，需要重新选择对接方式。是否确认取消？", "取消授权", {type: "warning"});
      const data = await merchantApi.cancelQywxBuild(this.route.query.id);
      this.qywxInfo = data || {};
      this.$message.success("已取消授权");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/el-tabs";
.defaultViewStyle{
  :deep(.form-page){
    padding-right: 0;
  }
}
.qywx-empty {
  color: #909399;
  padding: 8px 0;
}
.qywx-hint {
  font-size: 12px;
  color: #909399;
  line-height: 18px;
  margin-bottom: 8px;
  word-break: break-all;
}
// 主页地址：点击复制，故不显示可点击的链接色，改用普通字色 + 指针
.qywx-copy-url {
  color: var(--el-color-primary);
  cursor: pointer;
  word-break: break-all;
  &:hover {
    text-decoration: underline;
  }
}

</style>